
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["generateCsv"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d45ae4c9d9cdbc43d3a8.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "d45ae4c9d9cdbc43d3a8.worker.js");
					addMethods(w, methods)
					
					return w
				}
			